import { Card } from "antd"
import TemplateCardExtra from "./TemplateCardExtra"
import { corners, spacings } from "themes/variables"
import DOMPurify from "dompurify"
import styles from "./index.module.css"
import PropTypes from "prop-types"

const TemplateView = ({ createdAt, selectedTemplateLog, setSelectedTemplateLog }) => {
  return (
    <Card className={styles.templateCard} extra={<TemplateCardExtra created_at={createdAt} setSelectedLog={setSelectedTemplateLog} />}>
      <div
        style={{ background: "#fafbfc", padding: spacings.M, borderRadius: corners.XS }}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selectedTemplateLog?.body || "") }}
      />
    </Card>
  )
}

TemplateView.propTypes = {
  createdAt: PropTypes.string,
  selectedTemplateLog: PropTypes.object,
  setSelectedTemplateLog: PropTypes.func
}

export default TemplateView
